import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as router from '@attain-apps/fe/web/main/lib/router'

import * as state from '../../../../../state'

import * as agentsTab from './agents-tab'
import * as appsTab from './apps-tab'
import * as generalTab from './general-tab'
import * as integrationsTab from './integrations-tab'
import * as usersTab from './users-tab'

@ngCore.Component({
  imports: [
    ds.tabs.floatingHorizontal.Component,
    ds.tabs.tab.Directive,
    ds.layout.page.Component,
    ds.layout.page.child.header.Component,
    generalTab.Component,
    appsTab.Component,
    usersTab.Component,
    agentsTab.Component,
    integrationsTab.Component,
  ],
  selector: 'atn-zone-page',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.tenants.Collection} */
  public readonly tenantsEc = ngCore.inject(state.admin.tenants.Collection)

  /** @see {@link state.admin.zones.Collection} */
  public readonly zonesEc = ngCore.inject(state.admin.zones.Collection)

  /** @see {@link router.Router} */
  private readonly _router = ngCore.inject(router.Router)

  /** Name of the selected tenant*/
  private readonly _tenantNameSg = ngCore.computed(
    (
      tenant = this.tenantsEc.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal(),
    ) => tenant?.name,
  )

  /** Alias of selected tenant*/
  private readonly _tenantAliasSg = ngCore.computed(
    (
      tenant = this.tenantsEc.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal(),
    ) => tenant?.alias,
  )

  /** Name of selected zone*/
  public readonly zoneNameSg = ngCore.computed(
    (
      zone = this.zonesEc.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal(),
    ) => zone?.name,
  )
  /** Alias of selected zone*/
  private readonly _zoneAliasSg = ngCore.computed(
    (
      zone = this.zonesEc.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal(),
    ) => zone?.alias,
  )

  /** @see {@link state.admin.contexts.Feature} */
  private readonly _contextsFeature = ngCore.inject(
    state.admin.contexts.Feature,
  )

  /** @see {@link state.me.Feature} */
  private readonly _meFeature = ngCore.inject(state.me.Feature)

  /**
   * Breadcrumbs displayed in page header
   */
  public readonly breadcrumbsSg = ngCore.computed(
    (
      alias = this._zoneAliasSg(),
      tenant = this.tenantsEc.plugins.currentEntityPlugin.feature.selectors
        .getEntity()
        .asSignal(),
    ) =>
      [
        {
          name: 'Tenants',
          url: this._router.ngRouter.createUrlTree(['/admin/tenants']),
        },
        {
          name: this._tenantNameSg() ?? this._tenantAliasSg() ?? '',
          url: tenant
            ? this._contextsFeature.selectors.getUrlForTenant(tenant).asSignal()
            : undefined,
        },
        {
          name: this.zoneNameSg() ?? alias ?? '',
        },
      ] satisfies readonly ds.layout.page.child.header.models.Breadcrumb[],
  )

  /** Whether the Users tab is available for the current admin user */
  public readonly canManageUsersSg = ngCore.computed(
    (
      context = this._contextsFeature.selectors.activeEntityContext.asSignal(),
      currentUser = this._meFeature.selectors.currentUser.asSignal(),
    ) =>
      state.admin.userAssignment.models.User.canManageUsersForContext(
        currentUser,
        context,
      ),
  )
}
